import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getMerchantOverrides } from 'Services';
import { useTranslation } from 'react-i18next';
import { RQ_MERCHANT_OVERRIDES } from 'Utils';
import { transformMerchantOverrides } from '../helper';

function useMerchantOverrides() {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    const { data, isLoading } = useQuery([RQ_MERCHANT_OVERRIDES], () => getMerchantOverrides(templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0),
        select: transformMerchantOverrides(t),
        /** @note If Level === ACQUIRER aggregateData is calculated
         * in the BE using a worker thread (async operation). The calculation
         * can take some time to finish. As we don't have yet a way to notify the FE
         * when the calculation is done, we have a temporary solution to keep fetching every
         * 30s. */
        refetchInterval: 30000
    });
    return { isLoading, data: data || [] };
}

export default useMerchantOverrides;
